import { Payment } from '@/models/api/payment/payment'
import { Order } from '@spa/store/modules/orderHistory/types'

/**
 * 再決済（/reorder/payment）において元注文と同じ支払い方法を選択できるかどうか
 *
 * - payment-error: その支払い方法で一度エラーになっているので同じ支払い方法を許可しない
 * - それ以外（基本的にはpayment-requested）: 支払い手続きの途中で離脱したと思われるので、同じ支払い方法を許可する
 *
 * @see https://github.com/Everforth/growthpalette-front/issues/7843
 *
 * - キャリア決済の場合、元注文と異なるキャリアでの決済を許可するかどうか
 * - クレジットカード（3Dセキュア）の場合、元注文と異なるカードでの決済を許可するかどうか
 * について、クライアント確認のうえ、どちらも一律許可しない（キャリア決済、クレジットカード全体を許可しない）こととなった。
 * @see https://github.com/Everforth/growthpalette-front/issues/7843#issuecomment-1982222304
 */
export function filterPaymentMethodBasedOnOriginalOrder(
  list: Payment[],
  originalOrder: Order
): Payment[] {
  if (originalOrder.salesOrderStatus === 'payment-error') {
    return list.filter(payment => payment.id !== originalOrder.payment.method.kind)
  }

  return list
}
